'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _get = require('./get');

var _get2 = _interopRequireDefault(_get);

var _has = require('./has');

var _has2 = _interopRequireDefault(_has);

var _keyOrIndexToKey = require('./keyOrIndexToKey');

var _keyOrIndexToKey2 = _interopRequireDefault(_keyOrIndexToKey);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (keyPath) {
    return function (parcelData) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = (0, _getIterator3.default)(keyPath), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var key = _step.value;

                if (!(0, _has2.default)(key)(parcelData)) {
                    var stringKey = (0, _keyOrIndexToKey2.default)(key)(parcelData);
                    return {
                        value: undefined,
                        key: stringKey,
                        meta: {},
                        child: undefined
                    };
                }
                parcelData = (0, _get2.default)(key)(parcelData);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        return parcelData;
    };
};


//////////////////
// WEBPACK FOOTER
// ./~/parcels/lib/parcelData/getIn.js
// module id = 342
// module chunks = 35783957827783